import { getLocalizedText as t } from '@vp-dst/localization-util';
import { ProductShapeIds as P } from '../settings';

export enum DownloadableTemplateType {
  PS = 'ADOBE_PHOTOSHOP',
  AI = 'ADOBE_ILLUSTRATOR',
}

export interface DownloadableTemplate {
  label: string;
  type: DownloadableTemplateType;
  url: string;
}

let productShapeIdToDownloadableTemplatesMap: {
  [productShapeId: string]: DownloadableTemplate[];
};
function getProductShapeIdToDownloadableTemplatesMap() {
  if (productShapeIdToDownloadableTemplatesMap === undefined) {
    productShapeIdToDownloadableTemplatesMap = {
      [P.NA_STANDARD_BUSINESS_CARD as string]: [
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Standard+Horizontal+NA+Photoshop.zip',
        },
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Standard+Horizontal+NA+Illustrator.zip',
        },
      ],
      [P.NA_VERTICAL_STANDARD_BUSINESS_CARD as string]: [
        {
          label: t('vertical'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Standard+Vertical+NA+Photoshop.zip',
        },
        {
          label: t('vertical'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Standard+Vertical+NA+Illustrator.zip',
        },
      ],
      [P.NA_ROUNDED_CORNER_BUSINESS_CARD as string]: [
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+RCBC+NA+(Horizontal)+Photoshop.zip',
        },
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+RCBC+NA+(Horizontal)+Illustrator.zip',
        },
      ],
      [P.NA_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD as string]: [
        {
          label: t('vertical'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+RCBC+NA+(Vertical)+Photoshop.zip',
        },
        {
          label: t('vertical'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+RCBC+NA+(Vertical)+Illustrator.zip',
        },
      ],
      [P.NA_SQUARE_BUSINESS_CARD as string]: [
        {
          label: t('download'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Square+NA+Photoshop.zip',
        },
        {
          label: t('download'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Square+NA+Illustrator.zip',
        },
      ],

      // EU

      [P.EU_STANDARD_BUSINESS_CARD as string]: [
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Standard+Business+Card+EU+Horizontal+Photoshop.zip',
        },
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Standard+Business+Card+EU+Horizontal+Illustrator.zip',
        },
      ],
      [P.EU_VERTICAL_STANDARD_BUSINESS_CARD as string]: [
        {
          label: t('vertical'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Standard+Business+Card+EU+Vertical+Photoshop.zip',
        },
        {
          label: t('vertical'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Standard+Business+Card+EU+Vertical+Illustrator.zip',
        },
      ],
      [P.EU_ROUNDED_CORNER_BUSINESS_CARD as string]: [
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Rounded+Corner+Business+Cards+EU+Horizontal+Photoshop.zip',
        },
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Rounded+Corner+Business+Cards+EU+Horizontal+Illustrator.zip',
        },
      ],
      [P.EU_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD as string]: [
        {
          label: t('vertical'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Rounded+Corner+Business+Cards+EU+Vertical+Photoshop.zip',
        },
        {
          label: t('vertical'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Rounded+Corner+Business+Cards+EU+Vertical+Illustrator.zip',
        },
      ],
      [P.EU_SQUARE_BUSINESS_CARD as string]: [
        {
          label: t('download'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Square+Business+Card+EU+Photoshop.zip',
        },
        {
          label: t('download'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Square+Business+Card+EU+Illustrator.zip',
        },
      ],
      [P.EU_SLIM_BUSINESS_CARD as string]: [
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Slim+Business+Card+EU+Horizontal+Photoshop.zip',
        },
        {
          label: t('horizontal'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Slim+Business+Card+EU+Horizontal+Illustrator.zip',
        },
      ],
      [P.EU_VERTICAL_SLIM_BUSINESS_CARD as string]: [
        {
          label: t('vertical'),
          type: DownloadableTemplateType.PS,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Photoshop/MP-745075+Slim+Business+Card+EU+Vertical+Photoshop.zip',
        },
        {
          label: t('vertical'),
          type: DownloadableTemplateType.AI,
          url:
            'https://s3-eu-west-1.amazonaws.com/safari-toucan/template-files/vistaprint/Illustrator/MP-745075+Slim+Business+Card+EU+Vertical+Illustrator.zip',
        },
      ],
    };
  }

  return productShapeIdToDownloadableTemplatesMap;
}

export function getDownloadableTemplates(productShapeId: string) {
  return getProductShapeIdToDownloadableTemplatesMap()[productShapeId] || [];
}
